// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ListContainer_container__yUYJv {
  margin: auto !important;
  justify-content: center !important;
  margin-bottom: 120px !important;
}
.ListContainer_forceLtr__413FF {
  direction: ltr !important;
  font-family: Inter !important;
  /* font-family: Estedad !important; */
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/ListContainer/ListContainer.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,+BAA+B;AACjC;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,qCAAqC;AACvC","sourcesContent":[".container {\r\n  margin: auto !important;\r\n  justify-content: center !important;\r\n  margin-bottom: 120px !important;\r\n}\r\n.forceLtr {\r\n  direction: ltr !important;\r\n  font-family: Inter !important;\r\n  /* font-family: Estedad !important; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ListContainer_container__yUYJv`,
	"forceLtr": `ListContainer_forceLtr__413FF`
};
export default ___CSS_LOADER_EXPORT___;
